import PropTypes from 'prop-types';
import NiceModal, { useModal } from '@ebay/nice-modal-react';

import Form from '@gef-ui/form-material/Form';
import { getMessage } from '@gef-ui/localization/messages';

import Dialog from 'app/components/MaterialDialog';
import Version from 'components/atoms/Version';
import PAGES from 'constants/pages';
import formDescriptorFn, {
	REPORT_PRODUCTION_CONTROL_FORM_NAME,
} from 'features/views/productionControl/reportProductionControl/form';

import ReportProductionControlBody from './ReportProductionControlBody';

const ReportProductionControlModal = NiceModal.create(({ onConfirm }) => {
	const modal = useModal();

	return (
		<Dialog
			modal={modal}
			title={getMessage('productionControl:productionControlReport')}
			content={
				<Form name={REPORT_PRODUCTION_CONTROL_FORM_NAME} formDescriptorFn={formDescriptorFn}>
					<ReportProductionControlBody onConfirm={onConfirm} />
				</Form>
			}
			version={
				<Version
					screenId={PAGES.productionControl.reportProductionControlModal.id}
					screenName={PAGES.productionControl.reportProductionControlModal.name}
				/>
			}
		/>
	);
});

ReportProductionControlModal.propTypes = {
	onConfirm: PropTypes.func.isRequired,
};

export default ReportProductionControlModal;
